import { IAdobeInteraction } from "@abbvie-epi/common/adobe-analytics";
import { Component, OnInit } from "@angular/core";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";

@Component({
    selector: "app-developing-the-tool",
    templateUrl: "./developing-the-tool.component.html",
    styleUrls: ["./developing-the-tool.component.scss"]
})
export class DevelopingTheToolComponent implements OnInit {
    public isVideoModalOpen: boolean = false;

    public tables: any = {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false
    };
    public openedTable: string;

    constructor(private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit(): void {}

    openTable(tableNumber: string) {
        this.openedTable = tableNumber;
        this.tables[tableNumber] = true;
        document.body.style.overflow = "hidden";

        this.trackModalOpenOrClose(tableNumber, "open");
    }

    closeTable() {
        this.trackModalOpenOrClose(this.openedTable, "close");
        this.tables[this.openedTable] = false;
        document.body.style.overflow = "scroll";
    }

    public hideVideoModal() {
        this.isVideoModalOpen = false;

        this.trackUserGuideOpenOrClose("close");
    }

    public openVideoModal() {
        this.isVideoModalOpen = true;

        this.trackUserGuideOpenOrClose("open");
    }

    public trackCta(id: string): void {
        const overrides: IAdobeInteraction = {
            link: {
                type: "internal"
            },
            component: {
                name: "cta",
                position: "content",
                type: "content"
            },
            content: {
                type: "link"
            },
            interaction: {
                type: "link"
            }
        };

        this.analyticsHelper.trackInteraction(id, overrides);
    }

    private trackUserGuideOpenOrClose(action: "open" | "close") {
        const analyticsOverrides = this.getBaseModalAnalytics();
        this.analyticsHelper.trackInteraction(`development-user-guide-${action}`, analyticsOverrides);
    }

    private trackModalOpenOrClose(tableNumber: string, action: "open" | "close") {
        const analyticsOverrides = this.getBaseModalAnalytics();
        const tag = `development-modal-${tableNumber}-${action}`;

        this.analyticsHelper.trackInteraction(tag, analyticsOverrides);
    }

    private getBaseModalAnalytics(): IAdobeInteraction {
        return {
            link: {
                type: "information modal"
            },
            component: {
                name: "modal",
                position: "content",
                type: "modal"
            },
            content: {
                type: "informational modal"
            },
            interaction: {
                type: "link"
            }
        };
    }
}
